import "./src/styles/global.css";
//Redux
import wrapWithProvider from "./wrap-with-provider";
export const wrapRootElement = wrapWithProvider;
